import React from 'react'
import shopPic from "../Assests/shoppic.jpg"
import "../styles/Slider.css"

const imgs =[
    {
        id : 1,
        img_path: {shopPic}
    },
    {
        id : 2,
        img_path: {shopPic}
    },
    {
        id : 3,
        img_path: {shopPic}
    }
]

export default function Slider() {
  return (
   <div className="slider">
    
   </div>
  )
}
